import React, { useLayoutEffect } from "react";
import Footer from "../components/footer/footer";
import SathyaSaiMenu from "../components/navbarmenu/navmenu";
import Banner from "../components/banner/banner";
import BottomBanner from "../components/bottombanner/bottombanner";
import Menucardforallpage from "../components/menucardforallpage/menucardforallpage";
import QuoteBanner from "../components/quotebanner/quotebanner";
import StudyCircle from "../components/studycircle/studycircle";

function StudyCirclePage() {
  useLayoutEffect(() => {
      document.title = 'Study Circle - Sri Sathya Sai Center of Milwaukee | ssscmke.org';
  }, []);
  return (
    <div className="StudyCircle">
        <SathyaSaiMenu />
        <Banner title="Sai Spiritual Education" pic="/images/sse-Banner.png"/>
        <QuoteBanner />
        <StudyCircle />
        <Menucardforallpage page="sse" />
        <BottomBanner />
        <Footer />
    </div>
  );
}
export default StudyCirclePage;
